import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { List, Row, Cell } from '../../../components/List';
import { VBox } from '../../../components/Box';
import { Loader } from '../../../components/Loader';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_VEHICLES } from '../../Vehicles/constants';
import { changeVehicleFilter, fetchVehicles } from '../../Vehicles/actions';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { selectVehicles } from '../../Vehicles/selectors';

const Container = styled.div`
  max-height: 300px;
  overflow: auto;
`;
const DropdownOptions = styled.ul`
  display: block;
  position: absolute;
  z-index: 10;
  box-sizing: border-box;
  border-radius: 0.375rem;
  top: 40px;
  left: 0;
  width: 100%;
  list-style: none;
  border: solid 1px #eee;
  padding: ${({ show }) => (show ? '0' : '0')};
  background-color: white;
  max-height: 100px;
  overflow: auto;
`;

const DropdownOption = styled.li`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? '#86b6fe3b' : 'white')};
  color: ${({ isSelected }) => (isSelected ? 'black' : 'inherited')};

  &:hover {
    background-color: #86b6fe3b;
    color: black;
  }
`;

const STATE = {
  items: [],
  string: null,
  shouldRenderItems: false,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.fetchItems();
  }

  onStringChange(evt) {
    let string = evt.target.value;
    this.setState({ string, shouldRenderItems: true });
    this._t = this.timeout(this.fetchItems.bind(this), 300, this._t);
  }

  fetchItems() {
    this.props.fetchItems(this.state.string);
  }

  mapItem(i) {
    return {
      id: i.id,
      label: i.id,
    };
  }
  handleInputBlur() {
    this.setState({ shouldRenderItems: false });
  }

  get items() {
    return this.props.items ?? [];
  }

  render() {
    return (
      <div style={{ position: 'relative' }}>
        <div style={{ backgroundColor: 'white', height: '36px', width: '100%' }}>
          <input
            className="form-control"
            name="string"
            onChange={this.onStringChange.bind(this)}
            onClick={() => this.setState({ shouldRenderItems: true })}
             onBlur={this.handleInputBlur.bind(this)}
            value={this.state.string ?? ''}
            placeholder=""
          />
{this.state.shouldRenderItems && this.renderItems()}
        </div>
      </div>
    );
  }

  renderItems() {
    if (this.props.work) return <Loader small />;
    if (!this.items || this.items?.length === 0) return 'No items';

    const getLabel = v => {
      const brand = v?.properties?.find(p => p?.propertyName?.name === 'brand_name')?.propertyValue?.value;
      const model = v?.properties?.find(p => p?.propertyName?.name === 'model_name')?.propertyValue?.value;
      return brand && model ? `${brand} ${model}` : v?.id;
    };

    return (
      <DropdownOptions onMouseDown={(e) => e.preventDefault()}>
      {this.items.map(i => {
        return (
          <DropdownOption
          key={i.id} onMouseDown={(e) => this.handleOptionClick(e, i)}
          >
            <Cell>
            {getLabel(i)}
            </Cell>
          </DropdownOption>
        );
      })}
    </DropdownOptions>
    );
  }
  handleOptionClick(event, item) {
    event.stopPropagation();
    this.props.onSelect(item);
  }
}

VehicleSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    items: selectVehicles(),
    work: selectWorks([REQUEST_VEHICLES]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchItems: string => {
      dispatch(changeVehicleFilter('searchString', string));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleSelection = compose(withConnect, withRouter)(VehicleSelectionComp);
